import { pipe, over, lensProp, defaultTo, when, has, unless, propEq, assoc, omit, objOf, assocPath, always, isNil, prepend, append, join, merge, converge, identity } from 'ramda';
import uuid from 'uuid/v4';

var http = function http(axios) {
  return axios;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var doFetch = function doFetch(fetch) {
  return function (_a) {
    var url = _a.url,
        config = __rest(_a, ["url"]);

    return fetch(url, config).then(function (resp) {
      if (!resp.ok) {
        return resp.text().then(function (value) {
          return Promise.reject(new Error(value));
        });
      }

      return resp.json().then(objOf('data'));
    });
  };
};

var createFetch = function createFetch(fetch) {
  return pipe( // default method to GET
  over(lensProp('method'), defaultTo('GET')), // data should be passed a body and should be stringified
  when(has('data'), unless(propEq('method', 'GET'), function (x) {
    return assoc('body', JSON.stringify(x.data), x);
  })), omit(['data']), doFetch(fetch));
};

var json = function json() {
  return function (http) {
    return pipe(assocPath(['headers', 'Content-Type'], 'application/json'), http);
  };
};

var jsonRpc = function jsonRpc() {
  return function (http) {
    return function (_a) {
      var method = _a.method,
          data = _a.data,
          rest = __rest(_a, ["method", "data"]);

      var id = uuid();
      return http(Object.assign({}, rest, {
        method: 'POST',
        data: {
          jsonrpc: '2.0',
          id: id,
          method: method,
          params: data
        }
      })).then(function (response) {
        if (response.data.id !== id) {
          return Promise.reject(new Error('Invalid response'));
        }

        if (response.data.error) {
          return Promise.reject(response.data.error);
        }

        return Promise.resolve(response.data.result);
      });
    };
  };
};

var middleware = function middleware() {
  var defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (http) {
    return function (version, method, params) {
      /* eslint-disable no-param-reassign */
      if (typeof version === 'string' && typeof method !== 'string') {
        params = method;
        method = version;
        version = null;
      }
      /* eslint-enable */


      var prefixedMethod = pipe(unless(always(isNil(version)), prepend("v".concat(version))), append(method), join('.'))([]);
      return pipe(merge({
        url: '/api/app'
      }), assoc('method', prefixedMethod), assoc('data', params), http)(defaultConfig);
    };
  };
};

var xray = function xray() {
  return function (http) {
    return pipe(converge(assocPath(['headers', 'X-Ray-Id']), [function () {
      return uuid();
    }, identity]), http);
  };
};

var fetch = createFetch(window.fetch);
var http$1 = fetch;

export { createFetch, http as createHttp, fetch, http$1 as http, json, jsonRpc, middleware, xray };
